<template>
<div class="pt-4 pt-sm-10 api-error-wrapper">
  <v-card class="api-error" :width="cardWidth">
    <v-card-title class="pt-sm-10 px-sm-10 pt-8 px-4 pb-0">
        <div class="icon-container mb-0 pt-sm-0 pt-2">
            <sc-image class="logo" :media="fields.ErrorImage" />
        </div>
        <div class="error-heading">
            <sc-text :field="fields.ErrorTitle"></sc-text>
        </div>
        </v-card-title>
    <v-card-text class="dialog-text-container px-sm-10 px-4 pb-6"><sc-rich-text :field="fields.ErrorText"></sc-rich-text></v-card-text>
    <v-card-actions class="justify-center pb-sm-10 px-sm-10  px-4 pb-4">
        <v-btn class="dialog-btn" @click="btnClick"><sc-text :field="fields.ErrorButtonLabel"></sc-text></v-btn>
    </v-card-actions>
  </v-card>
  </div>
</template>

<script>
import { RichText, Image, Text } from '@sitecore-jss/sitecore-jss-vue';
import challengerEnv from '../../lib/challengerEnv';

export default {
  name: 'ErrorBox',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        ErrorImage: {
          value: {
            src:  challengerEnv().sitecoreContentAPI.host + '/-/jssmedia/iol/data/media/img/alerticon.svg?iar=0&hash=F8E7C35F2375BAB29DEDAB11B3D130E9'
          }
        },
        ErrorTitle: {
          value: "Error"
        },
        ErrorText: {
          value: "<p>We're not sure what happened there, but please click back and we'll do our best to fix it.</p><p>If you continue to experience difficulties please contact Challenger on 133 566.</p>"
        },
        ErrorButtonLabel: {
          value: 'Back'
        }
      }),
    },
  },
    components: {
    ScText: Text,
    ScRichText: RichText,
    ScImage: Image,
  },
  computed: {
    ApiErrorIcon () {
        return this.fields.ErrorIcon.fields.IconName.value
    },
    cardWidth() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 345;
      }
      return 576;
    },
  },
  methods: {
      btnClick () {
        this.$router.go(-1)
      }
  }
};
</script>
<style lang="scss" scoped>
.api-error-wrapper {
  display: flex;
  justify-content: center;
}
.api-error {
  border-radius: 0 !important;
  box-shadow: none !important;
  border: 1px solid #cfcfcf !important;
}
.icon-container {
  width: 100%;
  text-align: center;
  justify-content: center;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-bottom: 0.75rem;
  }
  img {
    height: 180px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      height: 120px;
    }
  }
}
.v-card__title {
  line-height: 1;
}

.error-heading {
  width: 100%;
  font-size: 2rem;
  font-weight: map-get($font-weights, 'medium');
  margin-bottom: 94px;
  text-align: center;
  color: map-deep-get($colors, 'blue-text', 'base') !important;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    margin-bottom: 2rem;
    font-size: 1.375rem;
  }
}

.dialog-text-container {
  font-size: 1.125rem;
  text-align: center;
  padding-bottom: 167px;
  font-weight: map-get($font-weights, 'normal');
  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 1rem;
  }
  line-height: 140%;
  color: map-deep-get($colors, 'blue-text', 'base') !important;
}
.dialog-btn {
  background-color: map-deep-get($colors, 'blue-title', 'base') !important;
  width: 150px !important;
  height: 48px !important;
  border-radius: 0 !important;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    width: 100%;
    min-width: 100% !important;
  }
  &:hover {
    color: #00629b !important;
    background-color: #ffffff !important;
    border: 2px solid #00629b !important;
    &::v-deep {
      .v-btn__content {
        color: #00629b !important;
      }
    }
  }
  &::v-deep {
    .v-btn__content {
      color: map-deep-get($colors, 'white', 'base');
    }
  }
  &:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0;
  }
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0;
}
</style>
